export enum PriorityTypeEnum {
  LOW = 1,
  NORMAL = 2,
  HIGH = 3,
  URGENT = 4
}
